import React from "react";
import Header from "../../components/header";
import SettingsComponent from "../../components/settings";
import NavBar from "../../components/navBar";
import * as GS from "../../utils/globalStyles/background";

const Settings: React.FC = () => {
  return (
    <GS.BackgroundApp>
      <Header />
      {/* <SettingsComponent /> */}
      <GS.BodyContainer>
        <SettingsComponent />
      </GS.BodyContainer>
      <GS.NavContainer>
        <NavBar />
      </GS.NavContainer>
    </GS.BackgroundApp>
  );
};

export default Settings;
